// constants
import { PRODUCT_TO_ADD_TO_WISHLIST, STORE_ID_FOR_WISHLIST_AFTER_LOGIN } from './constants';

export const setProductToAddToWishlistAfterLogin = (productId: string) => {
  try {
    window.sessionStorage.setItem(PRODUCT_TO_ADD_TO_WISHLIST, productId);
  } catch (err) {
    return;
  }
};

export const getStoredProductToBeAddedToWishlist = () => {
  try {
    return window.sessionStorage.getItem(PRODUCT_TO_ADD_TO_WISHLIST) || '';
  } catch (err) {
    return '';
  }
};

export const removeStoredProductToBeAddedToWishlist = () => {
  try {
    window.sessionStorage.removeItem(PRODUCT_TO_ADD_TO_WISHLIST);
  } catch (err) {
    return;
  }
};

export const setStoreIdForWishlistAfterLogin = (storeId: string) => {
  try {
    window.sessionStorage.setItem(STORE_ID_FOR_WISHLIST_AFTER_LOGIN, storeId);
  } catch (err) {
    return;
  }
};

export const getStoredStoreIdForWishlistAfterLogin = () => {
  try {
    return window.sessionStorage.getItem(STORE_ID_FOR_WISHLIST_AFTER_LOGIN) || '';
  } catch (err) {
    return '';
  }
};

export const removeStoredStoreIdForWishlistAfterLogin = () => {
  try {
    window.sessionStorage.removeItem(STORE_ID_FOR_WISHLIST_AFTER_LOGIN);
  } catch (err) {
    return;
  }
};
